module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-roofing@2x.png?c1d42cc672f3ff6a330ade0a1a232e76";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-roofing@2x.png
// module id = 1047
// module chunks = 1